import { PhoneNumberFormat, PhoneNumberUtil } from 'google-libphonenumber';
const phoneNumberUtil = new PhoneNumberUtil();

export const formatNumber = (num: string, country = 'US') => {
  if (phoneNumberUtil.isPossibleNumberString(num, country)) {
    const parsePhoneNumber = phoneNumberUtil.parse(num, 'US');
    return phoneNumberUtil.format(parsePhoneNumber, PhoneNumberFormat.NATIONAL);
  } else {
    return num;
  }
};

export const formatNumberWithNationalCode = (phoneNumber: any): string => {
  if (!phoneNumber) {
    return '';
  }

  const phoneUtil = PhoneNumberUtil.getInstance();
  const countryCode = phoneNumber.startsWith('+') ? '' : 'US';
  try {
    const parsedPhoneNumber = phoneUtil.parseAndKeepRawInput(
      phoneNumber,
      countryCode
    );
    return phoneUtil.isValidNumber(parsedPhoneNumber)
      ? countryCode === 'US'
        ? formatNumber(phoneNumber)
        : phoneUtil
            .format(parsedPhoneNumber, PhoneNumberFormat.INTERNATIONAL)
            .replace(/-/g, ' ')
      : phoneNumber;
  } catch (e) {
    return '';
  }
};

export const formatNumberNoPlusIfUS = (phoneNumber: string) => {
  return phoneNumber?.startsWith('+1') ? phoneNumber.substring(1) : phoneNumber;
};

export const isPhoneNumber = (phoneNumber) => {
  const phoneUtil = PhoneNumberUtil.getInstance();
  const countryCode = phoneNumber?.startsWith('+') ? '' : 'US';
  try {
    const parsedPhoneNumber = phoneUtil.parseAndKeepRawInput(
      phoneNumber,
      countryCode
    );
    return phoneUtil.isValidNumber(parsedPhoneNumber);
  } catch (e) {
    return false;
  }
};

export const isPhoneNumberMatch = (
  phoneNumber1: string,
  phoneNumber2: string
) => {
  const phoneUtil = PhoneNumberUtil.getInstance();
  try {
    const match = phoneUtil.isNumberMatch(phoneNumber1, phoneNumber2);

    if (
      match === PhoneNumberUtil.MatchType.EXACT_MATCH ||
      match === PhoneNumberUtil.MatchType.NSN_MATCH
    ) {
      return true;
    }

    // Handle US numbers where one has leading "1" and the other doesn't
    if (match === PhoneNumberUtil.MatchType.SHORT_NSN_MATCH) {
      try {
        const e164_1 = convertNumberIntoE164(phoneNumber1);
        const e164_2 = convertNumberIntoE164(phoneNumber2);
        const normalizedMatch = phoneUtil.isNumberMatch(e164_1, e164_2);
        return (
          normalizedMatch === PhoneNumberUtil.MatchType.EXACT_MATCH ||
          normalizedMatch === PhoneNumberUtil.MatchType.NSN_MATCH
        );
      } catch {
        return false;
      }
    }

    return false;
  } catch (e) {
    return false;
  }
};

export const convertNumberIntoE164 = (phoneNumber: string) => {
  const phoneUtil = PhoneNumberUtil.getInstance();

  const countryCode = phoneNumber.startsWith('+') ? '' : 'US';
  const parsedPhone = phoneUtil.parseAndKeepRawInput(phoneNumber, countryCode);
  const e164Phone = phoneUtil.format(parsedPhone, PhoneNumberFormat.E164);

  return e164Phone;
};

export default phoneNumberUtil;
